import useStoreReferralAttributes from '../useStoreReferralAttributes';

const StoreReferralAttributes = () => {
  // This call will store whatever attributes are on the search query
  useStoreReferralAttributes();

  return null;
};

export default StoreReferralAttributes;
